module.exports = __webpack_public_path__ + "static/media/forward_modeling_2.7ad069f5.png";